import { render, staticRenderFns } from "./Flights.vue?vue&type=template&id=0cb0ca88&scoped=true"
import script from "./Flights.vue?vue&type=script&lang=js"
export * from "./Flights.vue?vue&type=script&lang=js"
import style0 from "./Flights.vue?vue&type=style&index=0&id=0cb0ca88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb0ca88",
  null
  
)

export default component.exports